<template>
	<v-card dark outlined class="stats-oee-card pa-3" style="background-color:#1E1E1E; border-color:#2D2D2D;">
		<div class="d-flex align-center justify-space-between mb-2">
			<div class="caption grey--text text-uppercase" style="letter-spacing:0.05em;">
				<v-icon small left color="#26C6DA">mdi-chart-donut</v-icon>{{ $ml.get('alarm_stats_oee') }}
			</div>
			<!-- Overall OEE badge -->
			<v-chip small :color="overallColor" dark class="font-weight-bold">
				{{ formatPct(overall) }}%
			</v-chip>
		</div>

		<!-- Big OEE number -->
		<div class="text-center mb-3">
			<div class="text-h3 font-weight-bold" :style="{ color: overallColorHex }">
				{{ formatPct(overall) }}%
			</div>
			<div class="caption grey--text">{{ $ml.get('alarm_stats_oee') }}</div>
		</div>

		<!-- 3 sub-metric cards -->
		<v-row no-gutters class="mb-3">
			<v-col cols="4" class="pr-1">
				<v-card outlined class="pa-2 text-center" style="background-color:#2D2D2D; border-color:#424242;">
					<div class="caption grey--text" style="font-size:10px; letter-spacing:0.04em;">{{ $ml.get('alarm_stats_availability') }}</div>
					<div class="subtitle-2 font-weight-bold mt-1" style="color:#66BB6A;">
						{{ formatPct(availability) }}%
					</div>
				</v-card>
			</v-col>
			<v-col cols="4" class="px-1">
				<v-card outlined class="pa-2 text-center" style="background-color:#2D2D2D; border-color:#424242;">
					<div class="caption grey--text" style="font-size:10px; letter-spacing:0.04em;">{{ $ml.get('alarm_stats_performance') }}</div>
					<div class="subtitle-2 font-weight-bold mt-1" style="color:#FFA726;">
						{{ formatPct(performance) }}%
					</div>
				</v-card>
			</v-col>
			<v-col cols="4" class="pl-1">
				<v-card outlined class="pa-2 text-center" style="background-color:#2D2D2D; border-color:#424242;">
					<div class="caption grey--text" style="font-size:10px; letter-spacing:0.04em;">{{ $ml.get('alarm_stats_quality') }}</div>
					<div class="subtitle-2 font-weight-bold mt-1" style="color:#26C6DA;">
						{{ formatPct(quality) }}%
					</div>
				</v-card>
			</v-col>
		</v-row>

		<!-- OEE Target progress bar -->
		<div>
			<div class="d-flex justify-space-between caption mb-1">
				<span class="grey--text">{{ $ml.get('alarm_stats_oee_target') }}</span>
				<span :style="{ color: overallColorHex }">{{ formatPct(overall) }} / 85%</span>
			</div>
			<v-progress-linear
				:value="oeeTargetPct"
				:color="overallColor"
				background-color="#2D2D2D"
				height="8"
				rounded
			></v-progress-linear>
		</div>
	</v-card>
</template>

<script>
export default {
	name : 'StatsOee',

	props : {
		availability : {
			type    : Number,
			default : 0,
		},
		performance : {
			type    : Number,
			default : 0,
		},
		quality : {
			type    : Number,
			default : 0,
		},
		overall : {
			type    : Number,
			default : 0,
		},
	},

	computed : {
		// Backend sends 0-1 fractions; compare thresholds as fractions too
		overallColor() {
			if (this.overall >= 0.85) return 'success';
			if (this.overall >= 0.60) return 'warning';
			return 'error';
		},

		overallColorHex() {
			if (this.overall >= 0.85) return '#66BB6A';
			if (this.overall >= 0.60) return '#FFA726';
			return '#EF5350';
		},

		// Progress bar scaled to 85% target (capped at 100%)
		// overall is 0-1, target is 0.85
		oeeTargetPct() {
			return Math.min(100, Math.round((this.overall / 0.85) * 100));
		},
	},

	methods : {
		// Convert 0-1 fraction to display percentage string
		formatPct(value) {
			if (value === null || value === undefined) return '0.0';
			return (Number(value) * 100).toFixed(1);
		},
	},
};
</script>

<style scoped>
.stats-oee-card {
	min-height: 200px;
}
</style>
